import React from "react";
import Slider from "./Slider";
import "../estilos/slider.css";

export default function Inicio() {
    return (
        <div></div>
   /*     <div className="contenedor-principal">
            <section className="contenido">
                <div className="hero-banner">
                    {/!*<Slider />*!/}
                    <div className="hero-overlay">
                        <h1>Expediciones MTB en Catamarca</h1>
                        <p>Rutas guiadas para todos los niveles.</p>
                        <div className="hero-cta">
                            <a href="/reservas" className="btn-principal">Reservar ahora</a>
                            <a href="/expediciones" className="btn-secundario">Ver rutas</a>
                        </div>
                        <ul className="hero-beneficios">
                            <li>Guias locales con experiencia</li>
                            <li>Rutas adaptadas a tu nivel</li>
                            <li>Seguridad, asistencia e hidratación</li>
                        </ul>
                    </div>
                </div>
            </section>
        </div>*/
    );
}